import React, { SyntheticEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '../../actions/resetPasswordActions';
import BackButton from '../../components/BackButton';
import ErrorResponse from '../../components/ErrorResponse';
import InfoElement from '../../components/InfoElement';
import Input from '../../components/Input';
import PrimaryButton from '../../components/PrimaryButton';
import ViewWrapper, { FormWrapper } from '../../components/ViewWrapper';
import { EMAIL_REGEX } from '../../constants';
import logo from '../../img/Airthings_Favicon.png';
import { Store } from '../../reducers';
import { RequestType } from '../../reducers/requestReducer';
import styles from '../registerUser/RegisterView.module.scss';
import SetNewPassword from './SetNewPassword';

const ResetPassword = (): JSX.Element => {
    const { t: txt } = useTranslation();
    const dispatch = useDispatch();
    const { loading: sendEmailLoading, error } = useSelector(
        (state: Store) => state.requests[RequestType.ResetPassword]
    );
    const [email, setEmail] = useState('');
    const [codeSent, setCodeSent] = useState(false);
    const [validateInput, setValidateInput] = useState(false);

    useEffect(() => {
        if (!sendEmailLoading && email && !error) {
            setCodeSent(true);
        }
    }, [sendEmailLoading]);

    const sendEmail = (e: SyntheticEvent<HTMLFormElement> | SyntheticEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        e.stopPropagation();
        const validEmail = EMAIL_REGEX.test(email);
        if (validEmail) {
            dispatch(resetPassword(email));
        } else {
            setValidateInput(true);
        }
    };

    const onChange = (value: string): void => {
        setEmail(value.trim());
    };

    return (
        <ViewWrapper>
            {codeSent && email ? (
                <SetNewPassword email={email} />
            ) : (
                <FormWrapper onSubmit={sendEmail} testAttr="reset-password">
                    <img src={logo} className={styles.logo} alt={txt('Logo.AirthingsLogo')} />
                    <BackButton headerText={txt('ResetPassword.ResetPassword')} />
                    <Input
                        label="User.Email"
                        type="email"
                        id="email"
                        required
                        autoComplete="email"
                        invalid={validateInput && !EMAIL_REGEX.test(email)}
                        onChange={onChange}
                        value={email}
                        leadingIcon="email"
                    />
                    <InfoElement
                        iconName="error_outline"
                        infoText={txt('ResetPassword.ResetPasswordDescription')}
                        testAttr="send-unique-code-message"
                    />
                    {error && <ErrorResponse error={`ErrorCodes.${error.error}`} testAttr={'reset-password-error'} />}
                    <PrimaryButton onClick={sendEmail} loading={sendEmailLoading} title={'ResetPassword.Next'} />
                </FormWrapper>
            )}
        </ViewWrapper>
    );
};
export default ResetPassword;
